import { useNavigate } from 'react-router';

import { PolicyFileIngestionTable } from './policy-file-ingestions/table';

export function Northlight() {
	const nav = useNavigate();
	const tab = window.location.pathname.split('/').pop();
	 return (
		<>
			<div>
				<h1 className="mb-4 text-center text-2xl font-semibold">
					NorthLight Policy Feed
				</h1>
			</div>
			<div className="mb-4 flex justify-end">
				
			</div>
				<PolicyFileIngestionTable />
			</>
	);
}
